import { ReactElement } from "react";
import cx from "clsx";
import { InformationIcon } from "@twilio-paste/icons/esm/InformationIcon";
import { SuccessIcon } from "@twilio-paste/icons/esm/SuccessIcon";
import { Box } from "@twilio-paste/core/box";
import { Card } from "@twilio-paste/core/card";
import { Heading } from "@twilio-paste/core/heading";
import { Text } from "@twilio-paste/core/text";

import {
  ConfirmationCardProps,
  ConfirmationCardVariant,
} from "@twiliointernal/e2-commons-shared-definitions";
import CompositeCallout from "../compositeCallout";
import TrackingAnchor from "../trackingAnchor";

import styles from "./ConfirmationCard.module.css";

const ConfirmationCard = ({
  calloutProps,
  details,
  id,
  title,
  variant,
  width = "40rem",
}: ConfirmationCardProps): ReactElement => (
  <Box
    as="div"
    className={styles.confirmationCardContainer}
    id={id}
    width={width}
  >
    <Box
      as="div"
      className={cx([
        styles.confirmationCardHeader,
        styles.confirmationCardHeaderContainer,
      ])}
    >
      {variant === ConfirmationCardVariant.information && (
        <InformationIcon
          decorative
          size="sizeIcon80"
          color="colorTextLinkStrong"
        />
      )}

      {variant === ConfirmationCardVariant.success && (
        <SuccessIcon decorative size="sizeIcon80" color="colorTextSuccess" />
      )}

      <Heading as="h2" variant="heading20" marginBottom="space0">
        {title}
      </Heading>
    </Box>

    {calloutProps && (
      <CompositeCallout {...calloutProps} marginBottom="space0" />
    )}

    <Card paddingBottom="space20">
      {Object.keys(details).map((item) => (
        <Box
          as="section"
          className={styles.confirmationCardListItem}
          key={details[item].label}
          marginBottom="space70"
        >
          <Text as="strong">{details[item].label}</Text>

          <Text as="p">
            {details[item].url ? (
              <TrackingAnchor
                href={details[item].url as string}
                showExternal={details[item].showExternal}
              >
                {details[item].value}
              </TrackingAnchor>
            ) : (
              details[item].value
            )}
          </Text>
        </Box>
      ))}
    </Card>
  </Box>
);

export default ConfirmationCard;
